module.exports = __webpack_public_path__ + "img/team.e2f7cbf9.png";